/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashflow_Bank_ActualInputs */

const vi_cashflow_bank_actual = /** @type {(inputs: Cashflow_Bank_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền thực về NH`)
};

/**

* @param {Cashflow_Bank_ActualInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cashflow_bank_actual = /** @type {((inputs?: Cashflow_Bank_ActualInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashflow_Bank_ActualInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashflow_bank_actual(inputs)
});